export const NetworkDependencyTypes = {
  JwtRepository: Symbol.for('JwtRepository'),
  JwtLocalStorageService: Symbol.for('JwtLocalStorageService'),
  JwtLocalStorageKey: Symbol.for('JwtLocalStorageKey'),
  JwtService: Symbol.for('JwtService'),
  JwtRefreshGateway: Symbol.for('JwtRefreshGateway'),
  JwtRefreshService: Symbol.for('JwtRefreshService'),
  CockpitApiListApiService: Symbol.for('CockpitApiListApiService'),
  PublicCockpitApiService: Symbol.for('PublicCockpitApiService'),
  AuthenticationRequiredService: Symbol.for('AuthenticationRequiredService'),
};
